import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
var resources = {
    ar: {
        translation: require('./translations/messages_ar.json'),
    },
    bg: {
        translation: require('./translations/messages_bg.json'),
    },
    cs: {
        translation: require('./translations/messages_cs.json'),
    },
    da: {
        translation: require('./translations/messages_da.json'),
    },
    de: {
        translation: require('./translations/messages_de.json'),
    },
    el: {
        translation: require('./translations/messages_el.json'),
    },
    en: {
        translation: require('./translations/messages_en.json'),
    },
    es: {
        translation: require('./translations/messages_es.json'),
    },
    fi: {
        translation: require('./translations/messages_fi.json'),
    },
    fr: {
        translation: require('./translations/messages_fr.json'),
    },
    he: {
        translation: require('./translations/messages_he.json'),
    },
    hi: {
        translation: require('./translations/messages_hi.json'),
    },
    hu: {
        translation: require('./translations/messages_hu.json'),
    },
    id: {
        translation: require('./translations/messages_id.json'),
    },
    it: {
        translation: require('./translations/messages_it.json'),
    },
    ja: {
        translation: require('./translations/messages_ja.json'),
    },
    ko: {
        translation: require('./translations/messages_ko.json'),
    },
    lt: {
        translation: require('./translations/messages_lt.json'),
    },
    ms: {
        translation: require('./translations/messages_ms.json'),
    },
    nl: {
        translation: require('./translations/messages_nl.json'),
    },
    nb: {
        translation: require('./translations/messages_no.json'),
    },
    pl: {
        translation: require('./translations/messages_pl.json'),
    },
    pt: {
        translation: require('./translations/messages_pt.json'),
    },
    ro: {
        translation: require('./translations/messages_ro.json'),
    },
    ru: {
        translation: require('./translations/messages_ru.json'),
    },
    sv: {
        translation: require('./translations/messages_sv.json'),
    },
    th: {
        translation: require('./translations/messages_th.json'),
    },
    tl: {
        translation: require('./translations/messages_tl.json'),
    },
    tr: {
        translation: require('./translations/messages_tr.json'),
    },
    uk: {
        translation: require('./translations/messages_uk.json'),
    },
    vi: {
        translation: require('./translations/messages_vi.json'),
    },
    zh: {
        translation: require('./translations/messages_zh.json'),
    },
};
var widgetInstance = i18n.createInstance();
widgetInstance
    // pass the i18n instance to react-i18next so the t function will be in the context.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
    resources: resources,
    react: {
        useSuspense: false,
    },
    fallbackLng: 'en',
    debug: true,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
})
    .then(function (result) { return result; })
    .catch(function (error) { return console.error(error); });
export default widgetInstance;
//# sourceMappingURL=i18next.js.map